import api from '../api'

export const postCompany = (params) => api.post('/admin/companies', params)

export const putCompany = (params) => api.put(`/admin/companies/${ params.id }`, params)

export const softDeleteCompany = (params) => api.patch(`/admin/companies/${ params.id }`)

export const attachCompanyModule = (params, { moduleId }) => api.put(`/company/${ moduleId }/attachmodule`, params)

export const detachCompanyModule = (params, { moduleId }) => api.delete(`/company/${ moduleId }/detachmodule`, { data: params })

export const putDefaultFarm = (params) => api.put(`/companies/farms/set-farm-default/${ params.farmId }`)

export const postClientCompany = (params) => api.post('/companies/clients_companies', params)

export const putClientCompany = (params) => api.put(`/companies/clients_companies/${ params.id }`, params)

export const softDeleteClientCompany = (params) => api.patch(`/companies/clients_companies/${ params.id }`)
